<template>

    <div>

          
       

        <section>
            <div id="form-wrapper" class="container ">

                <DynamicForm/>

            </div>
        </section> 

    </div>

</template>

<script>

    
    
    import DynamicForm from './DynamicForm'

    export default {
     
       name: 'FormView',


       components: { DynamicForm }



        
    }
</script>

<style scoped>





   
</style>


// WEBPACK FOOTER //
// src/FormView.vue